import Box from "@/components/Box";
import Currency from "@/tpo/Currency";
import Group from "@/tpo/Group";

import {
  cmpHomeDashboardBalanceFooterBorderRadius,
  cmpHomeDashboardBalanceFooterInnerPadding,
  cmpHomeDashboardBalanceFooterOuterPadding,
  cmpHomeDashboardSectionRowGap
} from "./dashboardLayout";

const footerTextProps = {
  fontFamily: "gilroyBold",
  fontSize: 16,
  lineHeight: "20px"
};

function BalanceLabel({ label, loading, children }) {
  return (
    <Group alignItems="center" gap={2} flexWrap="wrap" {...footerTextProps}>
      <Box as="span">{label}:</Box>
      {loading ? <Box as="span">—</Box> : children}
    </Group>
  );
}

export default function LatestOrdersPanelBalanceFooter({
  orderBalance,
  orderBalanceLoading,
  commissionBalances,
  commissionBalanceLoading
}) {
  return (
    <Box width="100%" flexShrink={0} px={cmpHomeDashboardBalanceFooterOuterPadding.px}>
      <Group
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        rowGap={cmpHomeDashboardBalanceFooterInnerPadding.py}
        columnGap={cmpHomeDashboardSectionRowGap}
        px={cmpHomeDashboardBalanceFooterInnerPadding.px}
        py={cmpHomeDashboardBalanceFooterInnerPadding.py}
        bg="haze"
        borderRadius={cmpHomeDashboardBalanceFooterBorderRadius}
      >
        <BalanceLabel label="Account balance" loading={orderBalanceLoading}>
          <Currency
            value={orderBalance?.value}
            symbol={orderBalance?.currencySymbol}
            fontSize={16}
            fontFamily="gilroyBold"
            showTrailingZeros
          />
        </BalanceLabel>
        <BalanceLabel label="Monthly commission" loading={commissionBalanceLoading}>
          {commissionBalances?.length ? (
            <Group gap={3} alignItems="center" flexWrap="wrap">
              {commissionBalances.map(balance => (
                <Currency
                  key={balance.id}
                  value={balance.pending}
                  symbol={balance.currencySymbol}
                  fontSize={16}
                  fontFamily="gilroyBold"
                  showTrailingZeros
                />
              ))}
            </Group>
          ) : (
            <Currency value={0} fontSize={16} fontFamily="gilroyBold" showTrailingZeros />
          )}
        </BalanceLabel>
      </Group>
    </Box>
  );
}
